export default __webpack_public_path__ + "static/media/science-img-two.8e458242.svg";